// src/components/PersistentTimer.js
import React from 'react';
import { useTimer } from '../context/TimerContext';
import { FaTimes } from 'react-icons/fa';
import '../styles/Study.css';

const PersistentTimer = () => {
    const { isTimerRunning, timerMode, timeLeft, isStudyPage, setIsTimerRunning } = useTimer();

    // Only show when timer is running and not on study page
    if (!isTimerRunning || isStudyPage) {
        return null;
    }

    // Format time (mm:ss)
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    // Handle stop timer
    const stopTimer = () => {
        setIsTimerRunning(false);
    };

    return (
        <div className="persistent-timer">
            <div className={`persistent-timer-badge ${timerMode}`} />
            <div className="persistent-timer-time">{formattedTime}</div>
            <div className="persistent-timer-status">{timerMode === 'work' ? 'Working' : 'Break'}</div>
            <div className="persistent-timer-close" onClick={stopTimer}>
                <FaTimes />
            </div>
        </div>
    );
};

export default PersistentTimer;